import { useNavigate } from "react-router-dom";
import "./Refund.css";

const Refund = () => {
    const navigate = useNavigate();

    const topics = [
        { 
            category: "Refund and Pricing",
            questions: [
                { 
                    text: "What is your refund policy?", 
                    link: "/what-is-your-refund-policy?" 
                },
                { 
                    text: "What payment methods do you accept?",
                    link: "/what-payment-methods-do-you-accept?" 
                },
                {
                    text: "How long does it take to process a refund?",
                    link: "/how-long-does-it-take-to-process-a-refund?"
                },
                {
                    text: "Can I upgrade or change my service plan after payment?",
                    link: "/can-i-upgrade-or-change-my-service-plan-after-payment?"
                }
            ]
        },
    ];

    return (
        <div className="rf-container">
            <header className="rf-header">
                <div className="rf-container-1200">
                    {/* <div className="rf-header-content">
                        <button 
                            className="rf-back-btn"
                            onClick={() => navigate(-1)}
                        >
                            <FaArrowLeft /> Back
                        </button>
                        <div className="rf-logo">
                            <a href="/">BooksComply</a>
                        </div>
                        <div className="rf-top-bar">
                            <a href="/submitrequest" className="rf-submit-btn">
                                <FaQuestionCircle className="btn-icon" /> Submit a request
                            </a>
                        </div>
                    </div> */}
                </div>
            </header>
            
            <main className="rf-main-content">
                <div className="rf-container-1200">
                    <nav className="rf-breadcrumb">
                        <ol>
                            <li><a href="/help">Help Center</a></li>
                            <li>Refund and Pricing</li>
                        </ol>
                    </nav>

                    <div className="rf-page-header">
                        <h1>Refund and Pricing</h1>
                        <p>Everything you need to start a company with BooksComply</p>
                    </div>

                    {/* <div className="rf-info-cards">
                        {refundInfo.map((info, index) => (
                            <div key={index} className="rf-info-card">
                                <div className="rf-info-icon-container">
                                    {info.icon}
                                </div>
                                <h3>{info.title}</h3>
                                <p>{info.description}</p>
                            </div>
                        ))}
                    </div> */}

                    <div className="rf-questions-section">
                        <div className="rf-questions-header">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                        <ul className="rf-questions-list">
                            {topics[0].questions.map((question, index) => (
                                <li key={index} className="rf-question-item">
                                    <a 
                                        href={question.link}
                                        className="rf-question-link"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            navigate(question.link);
                                        }}
                                    >
                                        {question.text}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="rf-contact-section">
                        <h2>Need more help with payments?</h2>
                        <p>Our support team is available to assist you with any questions about billing, refunds, or our services.</p>
                        <a href="/submitRequest" className="rf-contact-btn">Contact Support</a>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default Refund;